// export const BACKEND_URL = "http://122.160.74.251:8016/";
export const BACKEND_URL = "https://djangoobesitychat.azurewebsites.net/emotional/";
